import React, { useState } from 'react'
import Sidebar from '../../components/Common/Sidebar/Sidebar'
import AdminProfile from '../../components/AdminProfile/AdminProfile'
import MobileSideBar from '../../components/MobileSideBar/MobileSideBar'
import { useUserContext } from '../../context/UserContext'
import { RxHamburgerMenu } from 'react-icons/rx'
import { useNavigate, useParams } from 'react-router-dom'
import HorseForm from './HorseForm'
import { UPDATE_HORSE } from '../../apollo/mutations/horses'
import { useMutation } from '@apollo/client'
import { createToast } from '../../utils/Toast'

const Toast = createToast()

function HorseOwnership() {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [toggle, setToggle] = useState(false)
  const { onSignOutHandler } = useUserContext()
  const [updateHorse, { loading }] = useMutation(UPDATE_HORSE)

  const handleSubmit = async formData => {
    await updateHorse({
      variables: {
        input: {
          id: formData.id,
          changeOwnership: true,
          email: formData.email,
        },
      },
      refetchQueries: ['listHorses'],
    })
      .then(response => {
        if (response?.data.updateHorse) {
          Toast.fire({
            icon: 'success',
            title: 'Ownership Verified Successfully',
          })
          navigate('/horse-admin')
        }
      })
      .catch(error => {
        Toast.fire({
          icon: 'error',
          title: error.message || 'Error updating horse',
        })
      })
  }

  return (
    <div className="w-full h-screen flex">
      <Sidebar />
      <div className="admin-dashboard-card-section mx-auto w-[100%]">
        <div className="w-[90%] md:w-[95%] h-auto mx-auto mt-[45px] flex justify-between items-center">
          <div className="xl:hidden block" onClick={() => setToggle(!toggle)}>
            <RxHamburgerMenu className="w-5 h-5" />
          </div>
          {toggle && <MobileSideBar toggle={toggle} setToggle={setToggle} />}

          <AdminProfile setIsOpen={setIsOpen} isOpen={isOpen} />
        </div>
        <div className="w-[90%] md:w-[95%] pb-[50px] mt-[10px] mx-auto">
          <div className="w-full flex flex-col items-center  mb-5 sm:mb-0 h-auto">
            <h1 className="admin-dashboard"> {'Update Horse Ownership'}</h1>
            <HorseForm
              title="Update Horse Ownership"
              onSubmit={data => handleSubmit(data)}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default HorseOwnership
